export const initBlockData = {
  title: "Latest",
};

export const initEmptyBlockData = {
  title: "",
};
